import { useGetCanvassHouses } from "@/canvasses/canvassHousesCrud";
import type { Canvass } from "@/canvasses/types";
import { useStorage, type RemovableRef } from "@vueuse/core";
import { computed, toValue, type MaybeRefOrGetter } from "vue";
import { useTurfFilter } from "./useTurfFilter";

export function useTurfs(canvass: MaybeRefOrGetter<Canvass>) {
  const storedSelectedTurfId: RemovableRef<string | null> = useStorage(
    ["canvass", toValue(canvass).id, "selectedTurfId"].join(":"),
    null,
  );

  const selectedTurfId = computed<string | null>({
    get: () => {
      const turfId = storedSelectedTurfId.value;
      return turfId !== null && turfIds.value.includes(turfId) ? turfId : null;
    },
    set: (turfId) => {
      storedSelectedTurfId.value = turfId;
    },
  });

  const { canvassHouses, getCanvassHousesStatus } = useGetCanvassHouses(
    toValue(canvass).id,
  );

  const { turfIds, filteredCanvassHouses } = useTurfFilter(
    canvassHouses,
    selectedTurfId,
  );

  return {
    turfIds,
    selectedTurfId,
    filteredCanvassHouses,
    getCanvassHousesStatus,
  };
}
